// eslint-disable-next-line no-unused-vars
import { createTheme } from "@mui/material/styles";

export const primary = {
  main: "#4A96E9",
  contrastText: "#fff",
};

export const secondary = {
  main: "#8C1D40",
  contrastText: "#fff",
};

const theme = createTheme({
  palette: {
    primary,
    secondary,
  },

  typography: {
    fontFamily: "Arial",
    button: {
      textTransform: "none",
    },
  },
});

window.theme = theme;

export default theme;
